import { system } from './system-core.esm.js';

// port from @styled-system/color v.5.1.2

// eslint-disable-next-line @typescript-eslint/no-explicit-any
var config = {};
config.color = {
  property: 'color',
  scale: 'colors'
};
config.backgroundColor = {
  property: 'backgroundColor',
  scale: 'colors'
};
config.opacity = true;
config.bg = config.backgroundColor;
var color = system(config);

export default color;
export { color };
//# sourceMappingURL=color.esm.js.map
